import React from "react";
import "./title.scss"

const Title = ({ text }) => {
  return <h2 className="title">{text}</h2>;
};

export default Title;
